export const ERROR_DESC: {[key: string]: string} = {
  'Auth error': 'Неверный логин или пароль',
  'The selected email is invalid': 'Пользователь с такой почтой не найден',
  'The password field must be at least 6 characters': 'Пароль должен содержать минимум 6 символов',
  'The email has already been taken': 'Эта почта уже используется',
  'authneed_email_verified': 'Надо подтвердить почту',
  'Please wait before retrying': 'Письмо уже отправлено, повторите попытку позже'
};
